import { QueryClientProvider } from '@tanstack/react-query';

import './App.css';
import { ToastProvider } from './providers/ToastProvider';
import { AppRoutes } from './routes/AppRoutes';
import { createAppQueryClient } from './utils/createAppQueryClient';

const queryClient = createAppQueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppRoutes />
      <ToastProvider />
    </QueryClientProvider>
  );
}

export default App;
